var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#272830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C15.7348 24 15.4804 23.9177 15.2929 23.7712C15.1054 23.6247 15 23.426 15 23.2188V8.78125C15 8.57405 15.1054 8.37534 15.2929 8.22882C15.4804 8.08231 15.7348 8 16 8C16.2652 8 16.5196 8.08231 16.7071 8.22882C16.8946 8.37534 17 8.57405 17 8.78125V23.2188C17 23.426 16.8946 23.6247 16.7071 23.7712C16.5196 23.9177 16.2652 24 16 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2188 17H8.78125C8.57405 17 8.37534 16.8946 8.22882 16.7071C8.08231 16.5196 8 16.2652 8 16C8 15.7348 8.08231 15.4804 8.22882 15.2929C8.37534 15.1054 8.57405 15 8.78125 15H23.2188C23.426 15 23.6247 15.1054 23.7712 15.2929C23.9177 15.4804 24 15.7348 24 16C24 16.2652 23.9177 16.5196 23.7712 16.7071C23.6247 16.8946 23.426 17 23.2188 17Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCard);
export default __webpack_public_path__ + "static/media/open-card.8876fdb47defb4ca3eec40cc7197654e.svg";
export { ForwardRef as ReactComponent };